import React, { useState } from 'react';

/* Password Input */
const PasswordInput = ({
	name,
	placeholder,
	refCallback,
	errors,
	register,
	className,
}) => {
	const [showPassword, setShowPassword] = useState(false);
	return (
		<>
			<div className="flex items-center">
				<input
					type={showPassword ? 'text' : 'password'}
					placeholder={placeholder}
					name={name}
					id={name}
					ref={(r) => {
						if (refCallback) refCallback(r);
					}}
					className={`${className} ${errors && errors[name] ? 'border-red-500 text-red-700 -me-px' : ''
						}`}
					{...(register ? register(name) : {})}
					autoComplete={name}
				/>
				<span
					className="flex items-center bg-slate-500/5 px-3 h-[42px] w-[50px] py-1 border rounded-e -ms-px dark:border-white/10 dark:bg-white/5"
					onClick={() => {
						setShowPassword(!showPassword);
					}}
				>
					<i
						className={`${showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
							}`}
					></i>
				</span>
			</div>
		</>
	);
};

// const FormInput = ({
// 	label,
// 	type,
// 	name,
// 	placeholder,
// 	register,
// 	errors,
// 	className,
// 	labelClassName,
// 	labelContainerClassName,
// 	containerClass,
// 	refCallback,
// 	children,
// 	rows,
// 	...otherProps
// }) => {
// 	const Tag =
// 		type === 'textarea' ? 'textarea' : type === 'select' ? 'select' : 'input';
// 	return (
// 		<>
// 			{type === 'hidden' ? (
// 				<input
// 					type={type}
// 					name={name}
// 					{...(register ? register(name) : {})}
// 					{...otherProps}
// 				/>
// 			) : (
// 				<>
// 					{type === 'password' ? (
// 						<>
// 							<div className={containerClass ?? ''}>
// 								{label && (
// 									<div className={labelContainerClassName ?? ''}>
// 										<label className={labelClassName ?? ''} htmlFor={name}>
// 											{label}
// 										</label>
// 										{children}
// 									</div>
// 								)}
// 								<PasswordInput
// 									name={name}
// 									placeholder={placeholder}
// 									refCallback={refCallback}
// 									errors={errors}
// 									register={register}
// 									className={className}
// 								/>
// 								{errors && errors[name] && (
// 									<>
// 										<div className="absolute inset-y-0 end-0 flex items-center pointer-events-none pe-3">
// 											<i className="fa-solid fa-circle-exclamation text-xl text-red-500" />
// 										</div>
// 										<p className="text-xs text-red-600 mt-2">
// 											{' '}
// 											{errors[name]['message']}
// 										</p>
// 									</>
// 								)}
// 							</div>
// 						</>
// 					) : (
// 						<>
// 							{type === 'textarea' ? (
// 								<>
// 									<div className={`${containerClass ?? ''} relative`}>
// 										{label ? (
// 											<label className={labelClassName ?? ''} htmlFor={name}>
// 												{label}
// 											</label>
// 										) : null}
// 										<Tag
// 											placeholder={placeholder}
// 											name={name}
// 											id={name}
// 											rows={rows}
// 											ref={(r) => {
// 												if (refCallback) refCallback(r);
// 											}}
// 											className={`${className} ${errors && errors[name]
// 												? 'border-red-500 focus:border-red-500 text-red-700  pe-10'
// 												: ''
// 												}`}
// 											{...(register ? register(name) : {})}
// 											{...otherProps}
// 										/>
// 										{errors && errors[name] && (
// 											<>
// 												<div className="absolute inset-y-0 end-0 flex items-center pointer-events-none pe-3">
// 													<i className="fa-solid fa-circle-exclamation text-xl text-red-500" />
// 												</div>
// 												<p className="text-xs text-red-600 mt-2">
// 													{' '}
// 													{errors[name]['message']}
// 												</p>
// 											</>
// 										)}
// 									</div>
// 								</>
// 							) : (
// 								<>
// 									<div className={`${containerClass ?? ''} relative`}>
// 										{label ? (
// 											<label className={labelClassName ?? ''} htmlFor={name}>
// 												{label}
// 											</label>
// 										) : null}
// 										<Tag
// 											type={type}
// 											placeholder={placeholder}
// 											name={name}
// 											id={name}
// 											ref={(r) => {
// 												if (refCallback) refCallback(r);
// 											}}
// 											className={`${className} ${errors && errors[name]
// 												? 'border-red-500 focus:border-red-500 text-red-700  pe-10'
// 												: ''
// 												}`}
// 											{...(register ? register(name) : {})}
// 											{...otherProps}
// 										/>
// 										{errors && errors[name] && (
// 											<>
// 												<div className="absolute inset-y-0 end-0 flex items-center pointer-events-none pe-3">
// 													<i className="fa-solid fa-circle-exclamation text-xl text-red-500" />
// 												</div>
// 												<p className="text-xs text-red-600 mt-2">
// 													{' '}
// 													{errors[name]['message']}
// 												</p>
// 											</>
// 										)}
// 									</div>
// 								</>
// 							)}
// 						</>
// 					)}
// 				</>
// 			)}
// 		</>
// 	);
// };

const FormInput = ({
	label,
	type,
	name,
	placeholder,
	register,
	errors,
	className,
	labelClassName,
	labelContainerClassName,
	containerClass,
	refCallback,
	children,
	rows,
	accept, // Added for file input types
	multiple, // Added for multiple file selection
	...otherProps
}) => {
	const Tag =
		type === "textarea"
			? "textarea"
			: type === "select"
				? "select"
				: type === "file"
					? "input"
					: "input";

	return (
		<>
			{type === "hidden" ? (
				<input
					type={type}
					name={name}
					{...(register ? register(name) : {})}
					{...otherProps}
				/>
			) : (
				<>
					{type === "password" ? (
						<div className={containerClass ?? ""}>
							{label && (
								<div className={labelContainerClassName ?? ""}>
									<label className={labelClassName ?? ""} htmlFor={name}>
										{label}
									</label>
									{children}
								</div>
							)}
							<PasswordInput
								name={name}
								placeholder={placeholder}
								refCallback={refCallback}
								errors={errors}
								register={register}
								className={className}
							/>
							{errors && errors[name] && (
								<>
									
									<p className="text-xs text-red-600 mt-2">
										{errors[name]["message"]}
									</p>
								</>
							)}
						</div>
					) : type === "file" ? (
						<div className={`${containerClass ?? ""} relative`}>
							{label ? (
								<label className={labelClassName ?? ""} htmlFor={name}>
									{label}
								</label>
							) : null}
							<Tag
								type={type}
								name={name}
								id={name}
								accept={accept}
								multiple={multiple}
								ref={(r) => {
									if (refCallback) refCallback(r);
								}}
								className={`${className} ${errors && errors[name]
									? "border-red-500 focus:border-red-500 text-red-700  pe-10"
									: ""
									}`}
								{...(register ? register(name) : {})}
								{...otherProps}
							/>
							{errors && errors[name] && (
								<>
									
									<p className="text-xs text-red-600 mt-2">
										{errors[name]["message"]}
									</p>
								</>
							)}
						</div>
					) : type === "textarea" ? (
						<div className={`${containerClass ?? ""} relative`}>
							{label ? (
								<label className={labelClassName ?? ""} htmlFor={name}>
									{label}
								</label>
							) : null}
							<Tag
								placeholder={placeholder}
								name={name}
								id={name}
								rows={rows}
								ref={(r) => {
									if (refCallback) refCallback(r);
								}}
								className={`${className} ${errors && errors[name]
									? "border-red-500 focus:border-red-500 text-red-700  pe-10"
									: ""
									}`}
								{...(register ? register(name) : {})}
								{...otherProps}
							/>
							{errors && errors[name] && (
								<>
									
									<p className="text-xs text-red-600 mt-2">
										{errors[name]["message"]}
									</p>
								</>
							)}
						</div>
					) : type === "checkbox" ? (
						<>
						<div className={`${containerClass ?? ""} relative`}>
							<input
								type="checkbox"
								name={name}
								id={name}
								ref={(r) => {
									if (refCallback) refCallback(r);
								}}
								className={`${className} ${errors && errors[name]
									? "border-red-500 focus:border-red-500 text-red-700"
									: ""
									}`}
								{...(register ? register(name) : {})}
								{...otherProps}
							/>
							{label && (
								<label
									htmlFor={name}
									className={labelClassName ?? "ms-2 text-sm text-gray-700"}
								>
									{label}
								</label>
							)}
							
						</div>
						{errors && errors[name] && (
								<>
							
									<p className="text-xs text-red-600 mt-2 mb-2">
										{errors[name]["message"]}
									</p>
								</>
							)}
						</>
					)
						: (
							<div className={`${containerClass ?? ""} relative`}>
								{label ? (
									<label className={labelClassName ?? ""} htmlFor={name}>
										{label}
									</label>
								) : null}
								<Tag
									type={type}
									placeholder={placeholder}
									name={name}
									id={name}
									ref={(r) => {
										if (refCallback) refCallback(r);
									}}
									className={`${className} ${errors && errors[name]
										? "border-red-500 focus:border-red-500 text-red-700  pe-10"
										: ""
										}`}
									{...(register ? register(name) : {})}
									{...otherProps}
								/>
								{errors && errors[name] && (
									<>
										
										<p className="text-xs text-red-600 mt-2">
											{errors[name]["message"]}
										</p>
									</>
								)}
							</div>
						)}
				</>
			)}
		</>
	);
};


export default FormInput;